import Vue from "vue"
import height_expand from "~/components/transitions/heightExpand"
import animixin from "~/mixins/animations"

export default {
  mixins: [animixin],
  components: {
    height_expand,
  },
  mounted: function () {
    if (this.startfocus === true && process.client)
      window.document.getElementById(this._uid).focus()
    Vue.set(this, "innerValue", this.value.toString())
  },
  data: function () {
    return {
      focus: false,
      cmpFocus: false,
      innerValue: "",
    }
  },
  computed: {
    pictoClass: function () {
      var ret = {}

      ret[this.picto_type] = true
      return ret
    },
    classObj: function () {
      var ret = {}

      ret.error = !this.validity
      ret.disabled = this.disabled
      ret.softdisable = this.softdisabled
      ret.holdsPicto =
        this.picto.length > 0 || this.picto_type !== "material-icons"
      ret.leftPicto = this.pictoleft && ret.holdsPicto
      ret.rightPicto = !this.pictoleft && ret.holdsPicto
      ret.hasLabel = this.label.length > 0
      ret.focus = this.cmpFocus
      ret[this.type] = true
      return ret
    },
    cmpDisplayMin: function () {
      if (this.type === "number") {
        if (typeof this.displaymin !== "number") return this.min
        else return this.displaymin
      }
    },
    cmpDisplayMax: function () {
      if (this.type === "number") {
        if (typeof this.displaymax !== "number") return this.min
        else return this.displaymax
      }
    },
  },
  methods: {
    restrainNumber: function () {
      if (typeof this.innerValue === "number") {
        if (
          this.innerValue > this.cmpDisplayMax &&
          this.innerValue > this.cmpDisplayMin
        )
          this.innerValue = this.cmpDisplayMax
        if (
          this.innerValue < this.cmpDisplayMax &&
          this.innerValue < this.cmpDisplayMin
        )
          this.innerValue = this.cmpDisplayMin
      }
    },
    handleErrRedirect: function () {
      if (this.errlink && this.errlink.length) this.newtab(this.errlink)
    },
    innerKeyup: function (e) {
      if (e.key === "Enter") this.$emit("enter", e)
      else this.$emit("keyup", e)
    },
    inFocus: function () {
      window.document.getElementById(this._uid).focus()
    },
    innerFocus: function (e) {
      this.focus = true
      this.$emit("focus", e)
    },
    innerBlur: function (e) {
      this.focus = false
      this.$emit("blur", e)
    },
    update: function (e) {
      if (!(this.disabled || this.softdisabled) && !this.readonly)
        this.$emit("input", this.innerValue)
      else
        Vue.set(
          this,
          "innerValue",
          this.value.toString().substr(0, this.maxlength)
        )
    },
    computeAnistate: function () {
      if (!this.focus && this.cmpFocus) {
        this.aniSpeed = 0.1
        this.changeAniSate("decelerate")
      } else {
        this.aniSpeed = 0.15
        this.changeAniSate("standart")
      }
    },
  },
  props: {
    value: {
      default: "",
      type: [Number, String],
    },
    step: {
      type: Number,
      default: 1,
    },
    placeholder: {
      default: "",
      type: String,
    },
    label: {
      default: "",
      type: String,
    },
    errmsg: {
      default: "",
      type: String,
    },
    errlink: {
      default: "",
      type: String,
    },
    type: {
      default: "text",
      type: String,
    },
    displaymax: {
      //input_type === number
      type: Number,
      required: false,
    },
    displaymin: {
      //input_type === number
      type: Number,
      required: false,
    },
    max: {
      //input_type === number
      type: Number,
      required: false,
    },
    min: {
      //input_type === number
      type: Number,
      required: false,
    },
    maxlength: {
      default: 8192,
      type: [Number, String],
    },
    picto: {
      default: "",
      type: String,
    },
    pictoleft: {
      default: function () {
        return true
      },
      type: Boolean,
    },
    picto_type: {
      default: function () {
        return "material-icons"
      },
      type: String,
      validator: function (value) {
        return ["material-icons", "imgHolder", "font-awesome"].includes(value)
      },
    },
    validity: {
      default: function () {
        return true
      },
      type: Boolean,
    },
    errfocus: {
      default: function () {
        return false
      },
      type: Boolean,
    },
    softdisabled: {
      default: function () {
        return false
      },
      type: Boolean,
    },
    disabled: {
      default: function () {
        return false
      },
      type: Boolean,
    },
    readonly: {
      default: function () {
        return false
      },
      type: Boolean,
    },
    startfocus: {
      default: function () {
        return false
      },
      type: Boolean,
    },
    focuserr: {
      default: function () {
        return true
      },
      type: Boolean,
    },
  },
  watch: {
    value: function () {
      Vue.set(
        this,
        "innerValue",
        this.value.toString().substr(0, this.maxlength)
      )
    },
    max: function () {
      this.restrainNumber()
    },
    min: function () {
      this.restrainNumber()
    },
    innerValue: function (o, n) {
      if (this.type === "number") {
        if (this.innerValue.toString().length)
          this.innerValue = Number(
            this.innerValue.toString().replace(/[^0-9]/gim, "")
          )
        this.restrainNumber()
      }
      this.update()
    },
    focus: function () {
      this.computeAnistate()
      Vue.nextTick(() => {
        this.cmpFocus = this.focus
      })
    },
    validity: function () {
      if (!this.validity && this.focuserr && process.client) this.inFocus()
    },
  },
}
